import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import { tagForm } from 'tagManager';

import useFormFields from '../../hooks/useFormFields';
import scrollTo from '../../utils/scrollTo';
import ErrorView from '../errors/ErrorView';
import forgotcredentialErrors from '../errors/forgotcredentialErrors';
import OverlaySpinner from '../spinner/OverlaySpinner';
import { PrimaryButtonSto, TextInputSto } from '../sto';

function RetrievePassword(props) {
    const { formFields, setFormField } = useFormFields({
        username: '',
    });
    const { username } = formFields;
    const [isFormValid, setFormValidity] = useState(false);
    const [error, setError] = useState(null);
    const [isValidatingUsername, setIsValidatingUsername] = useState(false);
    const usernameError = 'pages.login.username.field.error';

    useEffect(() => {
        if (props.error) {
            setFormValidity(false);
        }
    }, [props.error]);

    useEffect(() => {
        setFormValidity(username.isValid);
    }, [username]);

    const handleInputChange = (event) => {
        const { value } = event.target;

        const isValid = value.length >= 1 ? true : value.length < 1 && username.isValid !== null ? false : null;

        const errorMessage = isValid === false ? usernameError : null;
        setFormField('username', { errorMessage, isValid, value });
    };
    const handleUsernameBlur = (e) => {
        const isValid = e.target.value.length >= 1;
        const errorMessage = !isValid ? usernameError : null;
        setFormField('username', { errorMessage, isValid });
    };

    const handleSubmitClick = async (event) => {
        event.preventDefault();
        scrollTo(0, 0);
        setError(null);
        setIsValidatingUsername(true);
        try {
            const response = await Auth.forgotPassword(username.value);
            tagForm({
                fields: {
                    username: username.value,
                },
                name: 'reset-password-step1',
                success: true,
            });
            const authResponse = {
                email: response.CodeDeliveryDetails.Destination,
                username: username.value,
            };
            props.onSubmit(authResponse);
        } catch (e) {
            const errorMessage = forgotcredentialErrors[e.code];
            setError(errorMessage || 'general.unexpectedErrorOccurred');
            tagForm({
                fields: {
                    username: username.value,
                },
                message: e.message,
                name: 'reset-password-step1',
                success: false,
            });
        } finally {
            setIsValidatingUsername(false);
        }
    };

    return (
        <div>
            <ErrorView error={error} />
            {isValidatingUsername && <OverlaySpinner />}
            <form onSubmit={handleSubmitClick}>
                <TextInputSto
                    errorMessage={username.errorMessage}
                    isValid={username.isValid}
                    label="pages.login.username.field"
                    name="username"
                    onBlur={handleUsernameBlur}
                    onChange={handleInputChange}
                    placeholder="pages.login.username.placeholder"
                    value={username.value}
                />

                <div>
                    <div className="wrapper-button-sto-container">
                        <PrimaryButtonSto disabled={!isFormValid} labelKey="pages.button.submit" type="submit" />
                    </div>
                </div>
            </form>
        </div>
    );
}
export default RetrievePassword;
